import { PAVE_URL_PATH } from './config';
import { handlePaveRedirect } from './api';

export const directToPave = (sessionID) => {
  handlePaveRedirect(sessionID)
    .then(({ status, data }) => {
      if (status === 200) {
        const redirectUrl =
          data && data.redirect_url ? data.redirect_url : PAVE_URL_PATH;
        if (redirectUrl) {
          window.location.replace(`${redirectUrl}`);
        }
      }
    })
    .catch(() => {
      console.log('error');
    });
};
